import React from 'react';
import { Outlet } from 'react-router-dom';

const GeneralRoute = ({  }) => {  
  return (
    <div className="layout-general">
      <Outlet />
    </div>
  );
};


export default GeneralRoute;